/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_CaptionInputs */

const en_why_listening_compare_caption = /** @type {(inputs: Why_Listening_Compare_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening compared with other apps`)
};

const es_why_listening_compare_caption = /** @type {(inputs: Why_Listening_Compare_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening comparado con otras apps`)
};

/**
* | output |
* | --- |
* | "Listening compared with other apps" |
*
* @param {Why_Listening_Compare_CaptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_caption = /** @type {((inputs?: Why_Listening_Compare_CaptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_CaptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_caption(inputs)
	return en_why_listening_compare_caption(inputs)
});